import {
  CmsComponentMapping,
  CORE_CMS_COMPONENT_MAPPING,
} from '@domgen/dgx-fe-cms';
import { SELF_FIX_CMS_COMPONENT_MAPPING } from '@self-fix/shell';

export const APP_CMS_COMPONENT_MAPPING: CmsComponentMapping = {
  ...CORE_CMS_COMPONENT_MAPPING,
  ...SELF_FIX_CMS_COMPONENT_MAPPING,
};
